import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { rankedRows } from "../../utils/analyticsLabels";
import ChartFrame from "./ChartFrame";
import { formatShare, sharePercent } from "./format";

// Barras horizontais por ordem, numa so cor (spec do redesign, R7), para uma dimensao com 4 ou mais
// valores: o rotulo diz o que cada barra e, e a cor nao precisa de distinguir chaves. O que falta para o
// total vem no fim, a cinzento. Quem precisa das linhas todas, com as de valor 0, e dos nomes sem traducao
// passa as suas em `rows`, e o `breakdown` serve so de total (e, com `rows`, so ficam vazias sem linhas). Os numeros estao no texto de cada linha, e a barra e so desenho. No
// telemovel o rotulo passa para cima da barra. Um rotulo comprido parte em linhas e nunca leva reticencias
// (plano dos separadores, E5): a linha alinha ao topo, e a barra desce 4px para ficar a meio da primeira
// linha do texto (12px numa linha de 20px), como numa linha de uma so linha. Com `shareColumn` (o rotulo da
// coluna) o ficheiro descarregado leva tambem a percentagem de cada linha, numa coluna so do ficheiro; so o
// cartao das paginas a pede (D10 do plano das paginas), e as outras tabelas descarregam so as contagens.
const RankedBars = ({ title, note, lead, info, actions, breakdown, dimension, rows: givenRows, downloadName, shareColumn }) => {
  const { translate, language } = useLanguage();
  const rows = givenRows || rankedRows(breakdown, dimension, translate);
  const max = Math.max(0, ...rows.map((row) => row.value));
  const share = (value) => formatShare(value, breakdown.total, language);
  // Uma so largura para a coluna do valor em todas as linhas (a do texto mais longo, em ch), para as
  // pistas terem o mesmo comprimento e as barras estarem na mesma escala.
  const valueColumn = `${Math.max(1, ...rows.map((row) => share(row.value).length))}ch`;
  const table = {
    columns: [
      { key: "label", label: translate("analyticsCategory") },
      { key: "value", label: translate("analyticsCount"), numeric: true, format: share },
      ...(shareColumn ? [{ key: "share", label: shareColumn, downloadOnly: true }] : []),
    ],
    rows: shareColumn ? rows.map((row) => ({ ...row, share: sharePercent(row.value, breakdown.total) })) : rows,
  };
  return (
    <ChartFrame title={title} note={note} lead={lead} info={info} actions={actions} table={table} downloadName={downloadName} empty={givenRows ? givenRows.length === 0 : breakdown.total === 0}>
      <ul className="space-y-2" style={{ "--value-column": valueColumn }}>
        {rows.map((row) => (
          <li
            key={row.key}
            className="grid items-start gap-x-3 gap-y-1 text-sm grid-cols-[minmax(0,1fr)_var(--value-column)] sm:grid-cols-[minmax(0,11rem)_minmax(0,1fr)_var(--value-column)]"
          >
            <span className="col-span-2 sm:col-span-1 break-words" style={{ color: "var(--color-text-secondary)" }}>
              {row.label}
            </span>
            <span aria-hidden="true" className="h-3 mt-1 rounded" style={{ backgroundColor: "var(--color-surface-raised)" }}>
              <span
                className="block h-3 rounded"
                style={{ width: `${max ? (100 * row.value) / max : 0}%`, backgroundColor: row.muted ? "var(--chart-muted)" : "var(--chart-1)" }}
              />
            </span>
            <span className="tabular-nums text-right" style={{ color: "var(--color-text-primary)" }}>
              {share(row.value)}
            </span>
          </li>
        ))}
      </ul>
    </ChartFrame>
  );
};

export default RankedBars;
